    <div class="AMPrintingBoardingPasses_printing bg-am-medium-blue text-am-white modal-size">
        <div class="content">
            <img src="./assets/images/boardingpassnew.svg" alt="boardin passes" class="size-img">
        </div>
        <div class="content-info">
            <p class="fs-36px fw-bold">{{ 'boardingPasses.printingBoardingPasses' | translate }}</p>
            <p class="fs-25px fw-light">{{ boarginPassesInfo.currentNum }} {{ 'boardingPasses.count' | translate: boarginPassesInfo }}</p>
        </div>
    </div>

